import type { Translation } from '../i18n-types';

const it: Translation = {
  userGuide: 'Guida Utente',
  privacyPolicy: 'Informativa sulla Privacy',
  termsConditions: 'Termini e Condizioni',
  support: 'Supporto',
  abandoned: 'Abbandonato',
  completed: 'Completato',
  cancelled: 'Annullato',
  ended: 'Terminato',
  actionComments: 'Commenti Azioni',
  actionItem: 'Compito',
  actionItemPlaceholder: 'Compito...',
  actionItems: 'Compiti',
  actionPhaseDescription: "Aggiungi gli elementi d'azione, non puoi più raggruppare o votare i commenti",
  actions: 'Azioni',
  activate: 'Attiva',
  active: 'Attivo',
  activeRetros: 'Retros attivi',
  activeRetroUsers: 'Utenti retro attivi',
  activeStoryboards: 'Storyboard attivi',
  activeStoryboardUsers: 'Utenti storyboard attivi',
  addComment: 'Aggiungi un commento',
  addPersona: 'Aggiungi Persona',
  admin: 'Admin',
  adminCleanOldRetros: 'Elimina Retros più vecchi di {daysOld} giorni',
  adminCleanOldStoryboards: 'Elimina Storyboards più vecchi di {daysOld} giorni',
  adminPageAdmin: 'Amministrazione',
  adminPageAlerts: 'Avvisi',
  adminPageApi: 'Chiavi API',
  adminPageOrganizations: 'Organizzazioni',
  adminPageTeams: 'Teams',
  adminPageUsers: 'Utenti',
  adminPageSubscriptions: 'Abbonamenti',
  deleteSubscriptionConfirmation: 'Are you sure you want to delete this subscription?',
  deleteSubscription: 'Elimina Abbonamento',
  alertAllowDismiss: 'Permetti Chiusura',
  alertContent: 'Contenuto Avviso',
  alertContentPlaceholder: "Inserisci il contenuto dell'avviso",
  alertCreate: 'Crea Avviso',
  alertDelete: 'Elimina Avviso',
  alertDeleteConfirmation: 'Sei sicuro di voler eliminare questo avviso?',
  alertNamePlaceholder: "Inserisci il nome dell'avviso",
  alertRegisteredOnly: 'Solo Utenti Registrati',
  alerts: 'Avvisi',
  alertSave: 'Salva Avviso',
  alertTypePlaceholder: 'Seleziona il tipo di avviso',
  allVotesIn: 'Tutti i voti sono stati espressi',
  apiDocumentation: 'Documentazione API',
  apikeyCopyFailure: 'Impossibile copiare la chiave API negli appunti',
  apikeyCopySuccess: 'Chiave API copiata negli appunti',
  apiKeys: 'Chiavi API',
  applicationStatsError: "Errore durante il recupero delle statistiche dell'applicazione",
  appName: 'Thunderdome',
  appPreviewAlt: 'Anteprima di Thunderdome, Esperienza UI Agile Planning Poker',
  appSubtitle: 'App Open Source Agile Planning Poker',
  appVersion: 'versione {version}',
  associateTeam: 'Associa Team',
  authError: "Errore durante l'autenticazione del giocatore",
  autoFinishVoting: 'Votazione Automatica',
  avatarAltText: 'Avatar segnaposto',
  back: 'Indietro',
  battleAbandon: 'Abbandona Gioco',
  battleCreate: 'Crea Gioco',
  battleDelete: 'Elimina Gioco',
  battleEdit: 'Modifica Gioco',
  battleEditPointsDisabled: 'La votazione è attiva, non può modificare i punti consentiti.',
  battleJoin: 'Unisciti alla partita',
  battleName: 'Nome partita',
  battleRemoveError: 'Errore durante la rimozione della partita.',
  battleRemoveSuccess: 'Partita rimossa con successo.',
  battles: 'Partite',
  battlesActive: 'Partite attive',
  battlesActiveUsers: 'Utenti attivi in partite',
  becomeFacilitator: 'Diventa Facilitatore',
  becomeParticipant: 'Diventa Partecipante',
  becomeSpectator: 'Diventa Spettatore',
  blocked: 'Bloccato',
  blockers: 'Blocchi',
  blockersPlaceholder: 'Sono bloccato da...',
  brainstorm: 'Brainstorming',
  brainstormPhaseDescription: 'Aggiungi i tuoi commenti qui sotto',
  brainstormPhaseFeedbackVisibility: 'Visibilità Feedback Fase Brainstorming',
  brainstormVisibilityLabelConcealed: 'Feedback Nascosto',
  brainstormVisibilityLabelHidden: 'Feedback Nascosto',
  brainstormVisibilityLabelVisible: 'Feedback Visibile',
  cancel: 'Annulla',
  cannotBeUndone: 'Questa azione non può essere annullata.',
  checkIn: 'Check-in',
  checkinCommentDeleteError: "Errore nell'eliminazione del commento del check-in",
  checkinCommentError: 'Errore nel commentare il check-in',
  checkinError: 'Errore nel check-in',
  checkinMeetYesterdayGoalsQuestion: 'Hai raggiunto gli obiettivi di ieri?',
  checkins: 'Checkins',
  colorLegend: 'Legenda Colori',
  colorLegendNotSpecified: 'legenda non specificata',
  comment: 'Commento',
  comments: 'Commenti',
  conciseVotingResults: 'Risultati Votazione Sintetici',
  confirmDeleteRetro: 'Sei sicuro di voler eliminare questa retrospettiva?',
  createAccount: 'Creare un account',
  createAccountTagline: `Don't have an account?`,
  createAlertError: "Errore durante la creazione dell'avviso",
  createAlertSuccess: 'Avviso creato con successo',
  createARetro: 'Crea un retro',
  createAStoryboard: 'Crea uno storyboard',
  createBattleError: 'Errore durante la creazione della partita',
  createOrgError: "Errore durante la creazione dell'organizzazione",
  createRetro: 'Crea Retro',
  createRetroErrorMessage: 'Errore durante la creazione del retro',
  createStoryboard: 'Crea uno storyboard',
  createUserError: "Errore durante la creazione dell'utente",
  customizableBattleOptions: 'Opzioni di gioco personalizzabili',
  dateCreated: 'Data di Creazione',
  dateUpdated: 'Data di Aggiornamento',
  delete: 'Elimina',
  deleteActionItemError: "Errore durante l'eliminazione dell'elemento azione",
  deleteActionItemSuccess: 'Elemento azione eliminato con successo',
  deleteAlertError: "Errore durante l'eliminazione dell'avviso",
  deleteAlertSuccess: 'Avviso eliminato con successo',
  deleteBattle: 'Elimina partita',
  deleteBattleConfirmText: 'Sei sicuro di voler eliminare questa partita?',
  deleteBattleError: "Errore durante l'eliminazione della partita",
  deleteCheckinError: "Errore nell'eliminazione del check-in",
  deleteDepartment: 'Elimina Dipartimento',
  deleteDepartmentConfirmText: 'Sei sicuro di voler eliminare questo dipartimento?',
  deleteOrganization: 'Elimina Organizzazione',
  deleteOrganizationConfirmText: 'Sei sicuro di voler eliminare questa organizzazione?',
  deleteRetro: 'Elimina retro',
  deleteRetroErrorMessage: "errore durante l'eliminazione del retro",
  deleteStoryboard: 'Elimina Storyboard',
  deleteStoryboardErrorMessage: "errore durante l'eliminazione della storyboard",
  deleteTeam: 'Elimina Team',
  deleteTeamConfirmText: 'Sei sicuro di voler eliminare questo team?',
  deleteUserError: "Errore durante l'eliminazione dell'utente",
  demote: 'Degradare',
  demoteUserError: "Errore durante la declassificazione dell'utente",
  department: 'Dipartimento',
  departmentCreate: 'Crea Dipartimento',
  departmentCreateError: 'Errore durante la creazione del dipartimento',
  departmentDeleteError: "Errore durante l'eliminazione del dipartimento.",
  departmentDeleteSuccess: 'Dipartimento eliminato con successo.',
  departmentGetError: 'Errore durante la ricezione del dipartimento',
  departmentName: 'Nome Dipartimento',
  departmentNamePlaceholder: 'Inserisci il nome del dipartimento',
  departments: 'Dipartimenti',
  departmentSave: 'Salva Dipartimento',
  departmentTeamsGetError: 'Errore durante la ricezione dei team del dipartimento',
  departmentUsersGetError: 'Errore durante la ricezione degli utenti del dipartimento',
  discuss: 'Discussione',
  discussPlaceholder: 'Vorrei discutere...',
  done: 'Fatto',
  duplicateRetroSession: 'Esiste una sessione di retrospettiva duplicata per il tuo ID',
  duplicateStoryboardSession: 'Esiste una sessione di storyboard duplicata per il tuo ID',
  edit: 'Modifica',
  editColorLegend: 'Modifica Legenda',
  editRetro: 'Modifica retro',
  editStoryboard: 'Modifica Storyboard',
  email: 'Email',
  enterPasscode: 'Inserisci codice di accesso...',
  enterYourEmail: 'Inserisci la tua email',
  execute: 'Esegui',
  export: 'Esporta',
  facilitator: 'Facilitatore',
  facilitatorCode: 'Codice Facilitatore',
  facilitatorCodeOptional: 'Codice Facilitatore (Opzionale)',
  facilitatorCodePlaceholder: 'Inserisci un codice facilitatore opzionale',
  finalPoints: 'Punti finali',
  flag: 'Segnalazione',
  footerAuthoredBy: 'Realizzato con ❤️ da {authorOpen}Steven Weathers{authorClose}',
  forgotPassword: 'Hai Dimenticato la Password?',
  forgotPasswordSubtext:
    'Non preoccuparti! Inserisci semplicemente la tua email e ti invieremo le istruzioni per reimpostare la password.',
  returnToLogin: 'Return to Login',
  getAlertsError: 'Errore durante il recupero degli avvisi',
  getApikeysError: 'Errore durante il recupero delle chiavi API',
  getBattleError: 'Errore durante il recupero delle partite',
  getBattlesError: 'Errore durante il recupero delle partite',
  getCheckinsError: 'Errore nel recupero dei check-in',
  getOrganizationsError: "Errore durante l'ottenimento delle organizzazioni",
  getRetroErrorMessage: 'errore nel recupero del retro',
  getRetrosErrorMessage: 'errore nel recupero dei retros',
  getStoryboardErrorMessage: 'errore nel recupero dello storyboard',
  getStoryboardsErrorMessage: 'errore nel recupero degli storyboard',
  getTeamsError: "Errore durante l'ottenimento dei team",
  getUserError: "Errore durante l'ottenimento dell'utente",
  getUsersError: "Errore durante l'ottenimento degli utenti",
  goalsMet: 'Obiettivi raggiunti',
  goalsNotMet: 'Obiettivi non raggiunti',
  group: 'Gruppo',
  groupName: 'Nome del Gruppo',
  groupPhaseDescription: 'Trascina e raccogli i commenti simili',
  hostedDesc: '{linkOpen}Thunderdome.dev{linkClose} è un servizio ospitato gratuito (SaaS) senza pubblicità.',
  hostedOrSelfHosted: 'Servizio Ospitato o Auto-Ospitato',
  importCsv: 'Import stories from a CSV file',
  importCsvFileBadFileTypeError: 'Errore Tipo di file cattivo',
  importCsvFileReadFileError: 'File di lettura degli errori',
  importJiraXML: 'Importa storie da Jira XML',
  importJiraXMLBadFileTypeError: 'Errore Tipo di file cattivo',
  importJiraXMLReadFileError: 'Errore di lettura del file ',
  incorrectPassCode: 'Codice di accesso errato',
  inviteLinkCopyFailure: 'Impossibile copiare il link di invito negli appunti',
  inviteLinkCopySuccess: 'Link di invito copiato negli appunti',
  jiraXmlImport: 'Importazione XML Jira',
  joinCodeCopyFailure: 'Impossibile copiare il codice di partecipazione negli appunti',
  joinCodeCopySuccess: 'Codice di partecipazione copiato negli appunti',
  joinCodeLabelOptional: 'Codice di unione (Opzionale)',
  joinCodePlaceholder: 'Inserisci un codice di unione',
  joinRetro: 'Partecipa al retro',
  joinStoryboard: 'Partecipa allo storyboard',
  joinStoryboardError: "Errore nell'unirsi al storyboard, ricarica e riprova.",
  landingCountries: 'Utenti in oltre {count} paesi',
  landingFeatureOpenSourceText:
    "Dai un'occhiata al{repoOpen}Github repository{repoClose}per richiedere o contribuire a miglioramenti, traduzioni locali e correzioni di bug o a{donateOpen}Donate{donateClose}.",
  landingFeatureOpenSourceTitle: 'Open source',
  landingSalesPitch:
    'Remote team collaboration with agile story pointing, sprint retrospective, story mapping and async team check-in.',
  landingTitle: "Thunderdome è un'app di Agile Planning Poker",
  lastActive: 'Ultima Attività',
  leaveRetro: 'Abbandona retro',
  leaveStoryboard: 'Lascia Storyboard',
  legendRetroPlaceholder: 'Inserisci una legenda di un colore',
  loadingRetro: 'Caricamento Retro...',
  loadingStoryboard: 'Caricamento Storyboard...',
  login: 'login',
  loginForRetro: 'o {loginOpen}Accedi{loginClose} per partecipare al retro',
  loginForStoryboard: 'o {loginOpen}Accedi{loginClose} per partecipare allo storyboard',
  logout: 'Disconnettersi',
  logoutError: "Si è verificato un errore durante il logout dell'utente",
  makeFacilitator: 'Rendi Facilitatore',
  mfa2faLabel: 'Autenticazione 2FA/MFA',
  mfa2faRemove: 'Rimuovi 2FA/MFA',
  mfa2faRemoveFailure: 'Impossibile rimuovere 2FA/MFA',
  mfa2faRemoveSuccess: '2FA/MFA rimosso con successo',
  mfa2faRemoveText: 'Sei sicuro di voler rimuovere 2FA/MFA?',
  mfa2faSetup: 'Configura 2FA/MFA',
  mfaAuthError: 'Errore durante la convalida del token autenticatore',
  mfaConfirmToken: 'Conferma Token',
  mfaGenerateFailed: 'impossibile avviare la configurazione 2FA/MFA',
  mfaSecretKeyLabel: 'Chiave Segreta',
  mfaSetupFailed: 'validazione del token di configurazione 2FA/MFA fallita',
  mfaSetupIntro:
    "Scansiona il seguente codice QR con un'applicazione Autenticatore (come Google Autenticatore o Authy) e inserisci il token generato.",
  mfaSetupSuccess: '2FA/MFA abilitato con successo',
  mfaTokenLabel: 'Token Autenticatore',
  mfaTokenPlaceholder: "Inserisci il token dell'app autenticatore",
  myRetros: 'I miei retros',
  myStoryboards: 'I miei storyboard',
  name: 'Nome',
  needsImprovement: 'Migliorabile',
  nextPhase: 'Prossima azione',
  noComments: 'Nessun commento...',
  oldBattleCleanError: 'Errore durante la pulizia delle partite',
  oldGuestsCleanError: 'Errore durante la pulizia degli ospiti',
  oldRetrosCleanError: "Errore durante l'eliminazione dei retros.",
  oldStoryboardsCleanError: "Errore durante l'eliminazione dei storyboards.",
  openSource: 'Open Source',
  optional: '(Opzionale)',
  optionalLeadercodePlaceholder: 'Codice del leader opzionale per diventare leader',
  optionalPasscodePlaceholder: 'Codice di accesso opzionale per unirsi',
  organization: 'Organizzazione',
  organizationCreate: 'Crea Organizzazione',
  organizationDeleteError: "Errore durante l'eliminazione dell'organizzazione.",
  organizationDeleteSuccess: 'Organizzazione eliminata con successo.',
  organizationGetDepartmentsError: "Errore durante il recupero dei dipartimenti dell'organizzazione",
  organizationGetError: "Errore durante il recupero dell'organizzazione",
  organizationGetTeamsError: "Errore durante il recupero dei team dell'organizzazione",
  organizationGetUsersError: "Errore durante il recupero degli utenti dell'organizzazione",
  organizationName: "Nome dell'organizzazione",
  organizationNamePlaceholder: "Inserisci il nome dell'organizzazione",
  organizations: 'Organizzazioni',
  organizationsAndTeams: 'Organizzazioni e Team',
  organizationSave: 'Salva Organizzazione',
  owner: 'Proprietario',
  participation: 'Partecipazione',
  passCode: 'Codice di accesso',
  passCodeRequired: 'Codice di accesso obbligatorio per unirsi',
  personas: 'Persona',
  planAcceptanceCriteria: 'Criteri di accettazione',
  planAcceptanceCriteriaPlaceholder: 'Immettere i criteri di accettazione',
  planAdd: 'Aggiungi Storia',
  planDescription: 'Descrizione',
  planDescriptionPlaceholder: 'Immettere una descrizione',
  planLink: 'Link',
  planLinkInvalid: 'Link non è un URL assoluto valido, ad es.Include il protocollo (http/https) ',
  planLinkPlaceholder: 'Inserisci un link alla storia',
  planName: 'Nome Storia',
  planNamePlaceholder: 'Inserisci un nome per la storia',
  planPriority: 'Priorità',
  planPriorityBlocker: 'Blocker',
  planPriorityHigh: 'Alto',
  planPriorityHighest: 'Più alto',
  planPriorityLow: 'Basso',
  planPriorityLowest: 'Il più basso',
  planPriorityMedium: 'medio',
  planPriorityPlaceholder: 'Seleziona una priorità',
  planReferenceId: 'ID di riferimento',
  planReferenceIdPlaceholder: 'Immettere un ID di riferimento',
  plans: 'Storie',
  planSkip: 'Salta Storia',
  planType: 'Tipo Storia',
  planTypeBug: 'Bug',
  planTypeEpic: 'Epic',
  planTypePlaceholder: 'Types',
  planTypeSpike: 'Spike',
  planTypeStory: 'Story',
  planTypeSubtask: 'Subtask',
  planTypeTask: 'Task',
  pointAverageRounding: 'Arrotondamento Media dei Punti',
  pointed: 'Puntata ({count})',
  points: 'Punti',
  pointValuesAllowed: 'Valori dei Punti Consentiti',
  postComment: 'Pubblica Commento',
  primeDirective: 'Direttiva Primaria',
  promote: 'Promuovere',
  promoteUserError: "Errore durante la promozione dell'utente",
  questions: 'Domande',
  register: 'Registrati',
  reloadingRetro: 'Oops, ricaricamento della retrospettiva...',
  reloadingStoryboard: 'Oops, ricaricamento del storyboard...',
  remove: 'Rimuovi',
  removeBattle: 'Rimuovi partita',
  removeBattleConfirmText: 'Sei sicuro di voler rimuovere questa partita?',
  removeRetro: 'Rimuovi Retrospettiva',
  removeRetroConfirmText: 'Sei sicuro di voler rimuovere questa retrospettiva?',
  removeStoryboard: 'Rimuovi Storyboard',
  removeStoryboardConfirmText: 'Sei sicuro di voler rimuovere questo storyboard?',
  removeUser: 'Elimina Utente',
  removeUserConfirmText: 'Sei sicuro di voler eliminare questo utente?',
  requestVerifyEmail: 'Richiedi Email di Verifica',
  requestVerifyEmailFailure: "Errore durante l'invio dell'email di verifica",
  requestVerifyEmailSuccess: 'Email di verifica richiesta, controlla la tua casella di posta',
  retro: 'Retro',
  retroActionCommentAddError: "errore durante l'aggiunta di un commento alle azioni del retro",
  retroActionCommentDeleteError: "errore durante l'eliminazione di un commento alle azioni del retro",
  retroActionCommentEditError: 'errore durante la modifica del commento alle azioni del retro',
  retroActionItems: 'Compiti del Retro',
  retroAddError: 'Errore durante il tentativo di aggiungere la retrospettiva.',
  retroAddSuccess: 'Retrospettiva aggiunta con successo.',
  retroDeleted: 'Retrospettiva eliminata',
  retroFeedbackConcealed: 'Feedback Nascosto',
  retroFeedbackHidden: 'Feedback Nascosto',
  retroGifAdd: 'Aggiungi una GIF',
  retroGifClose: 'Chiudi la ricerca GIF',
  retroGifLoadMore: 'Carica altro',
  retroGifRateLimited: 'Limite di ricerca GIF raggiunto, riprova più tardi',
  retroGifRemove: 'Rimuovi GIF',
  retroGifSearchError: 'Ricerca GIF non riuscita, riprova',
  retroGifSearchNoResults: 'Nessuna GIF trovata',
  retroGifSearchPlaceholder: 'Cerca GIF...',
  retroGifSubmit: 'Pubblica',
  retroImprovePlaceholder: 'Cosa migliorare...',
  retroItems: 'Elementi retro',
  retroJoinError: "Errore nell'unirsi alla retrospettiva, ricarica e riprova.",
  retroMaxVotesPerUserLabel: 'Max Voti Gruppo (per Utente)',
  retroName: 'Nome Retro',
  retroNamePlaceholder: 'Inserisci un nome per il retro',
  retroQuestionPlaceholder: 'Vorrei chiedere...',
  retroRemoveError: 'Errore durante il tentativo di rimuovere la retrospettiva.',
  retroRemoveSuccess: 'Retrospettiva rimossa con successo.',
  retros: 'Retros',
  retroWorkedPlaceholder: 'Cosa ha funzionato bene...',
  role: 'Ruolo',
  rolePlaceholder: "Seleziona il ruolo dell'utente",
  save: 'Salva',
  search: 'Ricerca',
  searchLengthError: 'Il valore di ricerca deve essere di almeno 3 caratteri',
  selectTeam: 'Seleziona un Team',
  selfHostedDesc: 'In alternativa, puoi {linkOpen}eseguirlo sul tuo server{linkClose}.',
  sessionDuplicate: 'Esiste una sessione di gioco duplicata per il tuo ID',
  showActiveBattles: 'Mostra partite attive',
  showActiveRetros: 'Mostra i retros attivi',
  showActiveStoryboards: 'Mostra gli storyboard attivi',
  showBlockedCheckins: 'Mostra solo checkin che richiedono discussione',
  showCompletedActionItems: 'Mostra gli elementi azione completati',
  showVoters: 'Show Voters',
  skipped: 'Saltato',
  spectator: 'Spettatore',
  storyboard: 'Storyboard',
  storyboardAddColumn: 'Aggiungi Colonna',
  storyboardAddError: "Errore durante l'aggiunta dello storyboard.",
  storyboardAddGoal: 'Aggiungi Obiettivo',
  storyboardAddStoryToColumn: 'Aggiungi Storia alla Colonna',
  storyboardAddSuccess: 'Storyboard aggiunto con successo.',
  storyboardColumns: 'Colonne dello storyboard',
  storyboardDeleted: 'Storyboard eliminato',
  storyboardEditColumn: 'Modifica Colonna',
  storyboardGoalName: 'Nome Obiettivo',
  storyboardGoalNamePlaceholder: "Inserisci il nome dell'obiettivo",
  storyboardGoals: 'Obiettivi dello storyboard',
  storyboardPersonas: 'Personaggi dello storyboard',
  storyboardRemoveError: 'Errore durante la rimozione dello storyboard.',
  storyboardRemoveSuccess: 'Storyboard rimosso con successo.',
  storyboards: 'Storyboards',
  storyboardStories: 'Storie dello storyboard',
  columnPersonasTitle: 'Personaggi della colonna',
  columnPersonasEmpty: 'Nessun personaggio aggiunto a questa colonna',
  availablePersonas: 'Personaggi disponibili',
  availablePersonasEmpty: 'Nessun personaggio disponibile',
  allPersonasAdded: 'Tutti i personaggi sono stati aggiunti a questa colonna',
  team: 'Team',
  teamCheckins: 'Checkins di squadra',
  teamCreate: 'Crea Team',
  teamCreateError: 'Errore durante la creazione del team',
  teamCreateSuccess: 'Team creato con successo',
  teamDeleteError: "Errore durante l'eliminazione del team",
  teamDeleteSuccess: 'Team eliminato con successo',
  teamGetBattlesError: 'Errore durante il recupero delle partite del team',
  teamGetError: 'Errore durante il recupero del team',
  teamGetRetroActionsError: 'errore nel recupero delle azioni del retro',
  teamGetRetrosError: "Errore durante l'ottenimento delle retrospettive del team",
  teamGetStoryboardsError: "Errore durante l'ottenimento dei storyboard del team",
  teamGetUsersError: 'Errore durante il recupero degli utenti del team',
  teamName: 'Nome del team',
  teamNamePlaceholder: 'Inserisci il nome del team',
  teams: 'Teams',
  teamSave: 'Salva Team',
  teamUserRequiredToCheckin: "L'utente deve essere nella squadra per fare il check-in",
  teamUserRequiredToComment: "L'utente deve essere nella squadra per commentare",
  today: 'Oggi',
  todayPlaceholder: 'Oggi farò...',
  totalPoints: 'Totale',
  totalVotes: 'Voti Totali',
  type: 'Tipo',
  unknownWarrior: 'Giocatore sconosciuto',
  unpointed: 'Non puntato ({count})',
  updateActionItemError: "Errore nell'aggiornamento dell'elemento azione",
  updateActionItemSuccess: 'Elemento azione aggiornato con successo',
  updateAlertError: "Errore durante l'aggiornamento dell'avviso",
  updateAlertSuccess: 'Avviso aggiornato con successo',
  updateCheckinError: "Errore nell'aggiornamento del check-in",
  updateComment: 'Aggiorna Commento',
  userAdd: 'Aggiungi Utente',
  userAddError: "Errore durante l'aggiunta dell'utente.",
  userAddSuccess: 'Utente aggiunto con successo.',
  userEmail: 'Email Utente',
  userEmailPlaceholder: 'Enter the users email',
  userName: 'Nome Utente',
  userRemoveError: "Errore durante la rimozione dell'utente.",
  userRemoveSuccess: 'Utente rimosso con successo.',
  users: 'Utenti',
  verifyAccount: 'Verifica Account',
  verifyAccountFailedError:
    'Qualcosa è andato storto per verificare il tuo account, forse questo link è scaduto o è già stato utilizzato.',
  verifyAccountFailedTitle: 'Verifica fallita',
  verifyAccountLoading: 'Account di verifica ...',
  verifyAccountVerifiedThanks: 'Grazie per aver verificato la tua email.',
  verifyAccountVerifiedTitle: 'Account verificato',
  view: 'Visualizza',
  vote: 'Vota',
  voteCount: 'Conteggio Voti',
  votePhaseDescription: 'Vota per i gruppi che vorresti discutere maggiormente',
  voteResultsAverage: 'Media',
  voteResultsHighest: 'Più alto',
  votingFinish: 'Finire il voto',
  votingLocked: 'Votazione Bloccata',
  votingRestart: 'Riavvia il voto',
  warriorCreate: 'Crea Utente',
  warriorInvite: 'Invita un giocatore',
  warriorNudge: 'Spuntare',
  works: 'Funziona',
  writeCommentPlaceholder: 'Scrivi un commento...',
  yesterday: 'Ieri',
  yesterdayPlaceholder: 'Ieri ho...',
  yourRetros: 'I tuoi retros',
  yourStoryboards: 'I tuoi storyboard',
  addPlan: 'Aggiungi storia',
  battleNamePlaceholder: 'Inserisci il nome della partita',
  autoFinishVotingLabel: 'Termina automaticamente il voto quando tutti i giocatori hanno votato',
  averageRoundingOptions: {
    ceil: 'Ceil',
    floor: 'Floor',
    round: 'Round',
  },
  apiKeyCreateButton: 'Crea chiave API',
  apiKeyPrefix: 'Prefisso chiave',
  lastUpdated: 'Ultimo aggiornamento',
  apiKeysErrorRetrieving: 'Impossibile ottenere le chiavi API',
  apiKeyDeleteSuccess: 'Chiave API Eliminata',
  apiKeyDeleteFailed: 'Impossibile eliminare la chiave API',
  apiKeyUpdateSuccess: 'Tasto API aggiornato',
  apiKeyUpdateFailed: 'Impossibile aggiornare la chiave API',
  deactivate: 'Disattivare',
  profileErrorRetrieving: 'Errore per ottenere il tuo profilo',
  profileErrorUpdating: 'Errore riscontrato Aggiornamento del tuo profilo',
  profileUpdateSuccess: 'profilo aggiornato',
  passwordUpdated: 'Password aggiornata.',
  passwordUpdateError: 'Errore riscontrato tentativo di aggiornare la password',
  profileDeleteError: 'Errore riscontrato tentativo di eliminare il tuo account.',
  profileTitle: 'Il tuo profilo',
  profile: 'Profile',
  updatePassword: 'Aggiorna la password',
  deleteAccount: "Eliminare l'account",
  deleteAccountWarningStatement: 'Sei sicuro di voler eliminare il tuo account?',
  deleteConfirmButton: 'Conferma cancellazione',
  apiKeyNameInvalid: 'Immettere un nome chiave',
  apiKeyCreateSuccess: 'Nuova chiave API{keyName}creato e {onlyNowOpen}Verrà visualizzato solo ora{onlyNowClose}',
  apiKeyStoreWarning:
    'Ti preghiamo di memorizzare un posto sicuro perché non appena navighi da questa pagina, non saremo in grado di recuperare o ripristinare questo token generato.',
  apiKeyLimitReached: 'Hai consentito il numero massimo di chiavi API.',
  apiKeyUnverifiedUser: 'Solo gli utenti registrati verificati possono creare chiavi API.',
  apiKeyCreateFailed: 'Impossibile creare la chiave API',
  apiKeyName: 'Nome chiave',
  apiKeyNamePlaceholder: 'Immettere un nome chiave',
  create: 'Crea',
  close: 'Chiudi',
  country: 'Paese',
  company: 'Azienda',
  verified: 'Verificato',
  registeredUsers: 'Utenti Registrati',
  myBattles: 'Mie partite',
  createBattle: 'Crea una partita',
  countPlansPointed: '{totalPointed} di {totalPlans} storie puntate',
  myBattlesError: 'Errore durante la ricerca delle tue partite',
  warriorJoined: '{name} si è unito alla partita',
  warriorRetreated: '{name} ha lasciato la partita',
  planSkipped: 'Storia saltata',
  warriorVoted: '{name} havotato',
  warriorRetractedVote: '{name} haritirato il voto',
  battleDeleted: 'Partita eliminata',
  warriorNudgeMessage: 'pst... {name}, ti stiamo aspettando per il voto.',
  battle: 'Partita',
  warriors: 'Giocatori',
  battleSocketReconnecting: 'Ops, caricamento della partita...',
  battleSocketError: 'Errore durante la connessione alla partita ricaricare e riprovare.',
  battleLoading: 'Caricamento partita...',
  votingNotStarted: 'l voto non è ancora iniziato',
  password: 'Password',
  passwordPlaceholder: 'Inserisci una password',
  yourPasswordPlaceholder: 'Inserisci la tua password',
  confirmPassword: 'Conferma Password',
  confirmPasswordPlaceholder: 'Conferma la tua password',
  update: 'Aggiorna',
  reset: 'Reimposta',
  passwordResetError: 'Errore durante il tentativo di reimpostare la password',
  resetPassword: 'Reimposta Password',
  registerAsGuest: 'Registrati come Ospite',
  registrationDisabled: 'La registrazione è disabilitata.',
  userNamePlaceholder: 'Inserisci il tuo nome',
  guestRegisterError: 'Errore durante il tentativo di registrazione come ospite',
  registerError: 'Errore durante il tentativo di registrazione account',
  enlistToBattle: 'Arruolati per la Battaglia',
  loginForBattle: 'o {loginOpen}Accedi{loginClose} per unirti al Gioco',
  yourNamePlaceholder: 'Inserisci il tuo nome',
  createAccountFormTitle: 'Crea un Account {optionalOpen}(opzionale){optionalClose}',
  sendResetPasswordSuccess: 'Istruzioni per il reset password inviate a {email}',
  sendResetPasswordError: 'Errore durante il tentativo di invio reset password',
  chooseCountryPlaceholder: 'Scegli il tuo paese (opzionale)',
  locale: 'Lingua',
  companyPlaceholder: 'Inserisci la tua azienda (opzionale)',
  jobTitle: 'Titolo di Lavoro',
  jobTitlePlaceholder: 'Inserisci il tuo titolo di lavoro (opzionale)',
  enableBattleNotifications: 'Abilita le notifiche di gioco',
  avatar: 'Avatar',
  updateProfile: 'Aggiorna Profilo',
  guestUsers: 'Utenti Ospiti',
  maintenance: 'Manutenzione',
  cleanGuests: 'Pulisci Ospiti più vecchi di {daysOld} giorni',
  cleanBattles: 'Pulisci Giochi più vecchi di {daysOld} giorni',
  chooseLocalePlaceholder: 'Scegli la tua lingua preferita (opzionale)',
  importPlans: 'Importa Storie',
  selectFile: 'Seleziona file...',
  theme: 'Tema',
  assignees: 'Assegnatari',
  assigneeSelectPlaceholder: 'Seleziona un assegnatario da aggiungere',
  assigneeAdd: 'Aggiungi Assegnatario',
  allStoryWithCount: 'Tutte ({count})',
  userUpdate: 'Aggiorna Utente',
  userUpdateSuccess: 'Utente aggiornato con successo.',
  userUpdateError: "Errore nell'aggiornamento utente.",
  invites: 'Inviti',
  userInvites: 'Inviti Utente',
  userInviteSent: 'Invito utente inviato',
  userInviteConfirmDelete: 'Sei sicuro di voler eliminare questo invito utente?',
  userInviteDelete: 'Elimina Invito',
  acceptInvite: 'Accetta invito',
  rejectInvite: 'Rifiuta invito',
  rejectingInvite: 'Rifiuto in corso...',
  inviteRejected: 'Invito rifiutato',
  inviteRejectError: "Errore durante il rifiuto dell'invito",
  getUserInvitesError: 'Errore nel recupero degli inviti utente',
  expireDate: 'Data di Scadenza',
  addUserWillInviteNotFoundFieldNote:
    "Se l'utente non è registrato, verrà inviato un invito a registrarsi e unirsi al {pageType}.",
  inviteUserFieldNote: 'Verrà inviato un invito per unirsi al {pageType}.',
  requiresOrganizationMember: "L'utente deve già essere nell'Organizzazione.",
  teamUpdateSuccess: 'Team aggiornato con successo',
  teamUpdateError: "Errore nell'aggiornamento del Team",
  orgUpdateSuccess: 'Organizzazione aggiornata con successo',
  orgUpdateError: "Errore nell'aggiornamento dell'Organizzazione",
  deptUpdateSuccess: 'Dipartimento aggiornato con successo',
  deptUpdateError: "Errore nell'aggiornamento del Dipartimento",
  hideVoterIdentity: 'Nascondi Identità Votante',
  storyboardName: 'Nome Storyboard',
  storyboardNamePlaceholder: 'Inserisci un nome storyboard',
  retroPhaseTimeLimitMinLabel: 'Limite di tempo fase Brainstorm in minuti',
  phaseAutoAdvanceLabel: 'Avanza automaticamente le fasi',
  removeOnlyFacilitatorError: "Non è possibile rimuovere l'unico facilitatore",
  noGamesFound: 'Nessun gioco trovato, prova a crearne uno.',
  noRetrosFound: 'Nessuna retro trovata, prova a crearne una.',
  noStoryboardsFound: 'Nessuno storyboard trovato, prova a crearne uno.',
  retroDescription:
    'Una retrospettiva dello sprint è una revisione condotta dopo uno sprint che svolge un ruolo chiave nella metodologia Agile. Una retrospettiva dello sprint mira a determinare cosa è andato bene e dove hai avuto problemi e identificare aree dove puoi migliorare.',
  pokerDescription:
    'Lo scrum poker, noto anche come "planning poker" e "pointing poker", è una tecnica gamificata che i team di sviluppo usano per stimare lo sforzo delle attività di gestione del progetto. Queste stime sono basate sull\'input e il consenso dell\'intero gruppo, rendendole più coinvolgenti e accurate di altri metodi.',
  storyboardDescription:
    "La mappatura delle user story (storyboard) è una visualizzazione del percorso che un cliente compie con un prodotto, dall'inizio alla fine. Include tutte le attività che tipicamente completerebbero come parte di quel percorso.",
  estimationScaleNamePlaceholder: 'Inserisci nome scala',
  description: 'Descrizione',
  estimationScaleDescriptionPlaceholder: 'Inserisci descrizione scala',
  scaleType: 'Tipo Scala',
  estimationScaleTypePlaceholder: 'Seleziona tipo scala',
  scaleValues: 'Valori Scala',
  estimationScaleValuesPlaceholder: 'Inserisci valori separati da virgole',
  estimationScaleValuesHelp: 'Inserisci valori separati da virgole (es., 1, 2, 3, 5, 8)',
  estimationScaleIsPublic: 'Rendi questa scala pubblica',
  estimationScaleDefault: 'Imposta come scala predefinita',
  estimationScaleSave: 'Salva Scala',
  estimationScales: 'Scale di Stima',
  estimationScaleCreate: 'Crea Scala di Stima',
  estimationScaleCreateSuccess: 'Scala di stima creata con successo',
  estimationScaleCreateError: 'Errore nella creazione della scala di stima',
  estimationScaleUpdateSuccess: 'Scala di stima aggiornata con successo',
  estimationScaleUpdateError: "Errore nell'aggiornamento della scala di stima",
  estimationScaleRemoveSuccess: 'Scala di stima rimossa con successo',
  estimationScaleRemoveError: 'Errore nella rimozione della scala di stima',
  removeEstimationScaleConfirmText: 'Sei sicuro di voler rimuovere questa scala di stima?',
  removeEstimationScale: 'Rimuovi Scala di Stima',
  yes: 'Sì',
  no: 'No',
  isPublic: 'Pubblico',
  default: 'Predefinito',
  publicEstimationScales: 'Scale di Stima Pubbliche',
  organizationEstimationScales: 'Scale di Stima Organizzazione',
  teamEstimationScales: 'Scale di Stima Team',
  allowCumulativeVotingLabel: 'Permetti Voto Cumulativo (più di 1 voto per gruppo di elementi)',
  activeSubscriptions: 'Abbonamenti Attivi',
  retroTemplates: 'Template Retro',
  publicRetroTemplates: 'Template Retro Pubblici',
  organizationRetroTemplates: 'Template Retro Organizzazione',
  teamRetroTemplates: 'Template Retro Team',
  retroTemplateNamePlaceholder: 'Inserisci nome template',
  retroTemplateDescriptionPlaceholder: 'Inserisci descrizione template',
  format: 'Formato',
  retroTemplateIsPublic: 'Rendi questo template pubblico',
  retroTemplateSave: 'Salva Template',
  retroTemplateCreate: 'Crea Template Retrospettiva',
  retroTemplateCreateSuccess: 'Template retrospettiva creato con successo',
  retroTemplateCreateError: 'Errore nella creazione del template retrospettiva',
  retroTemplateUpdateSuccess: 'Template retrospettiva aggiornato con successo',
  retroTemplateUpdateError: "Errore nell'aggiornamento del template retrospettiva",
  retroTemplateRemoveSuccess: 'Template retrospettiva rimosso con successo',
  retroTemplateRemoveError: 'Errore nella rimozione del template retrospettiva',
  removeRetroTemplateConfirmText: 'Sei sicuro di voler rimuovere questo template retrospettiva?',
  removeRetroTemplate: 'Rimuovi Template Retrospettiva',
  retroTemplateDefault: 'Imposta come template predefinito',
  jiradatacenterLabel: 'Jira DataCenter',
  loginWithSSO: 'Accedi con {provider}',
  requestEmailChangeSuccess: 'Richiesta di cambio email inviata, controlla la tua casella di posta per le istruzioni',
  requestEmailChangeError: 'Errore durante il tentativo di cambio email',
  changeEmail: 'Cambia Email',
  errorChangingEmail:
    'Errore durante il tentativo di cambio email, forse questo link è scaduto o è già stato utilizzato.',
  emailChanged: 'Email cambiata con successo',
  newEmailToLogin: 'Da ora in poi, usa la tua nuova email per accedere.',
  newEmail: 'Nuova Email',
  enterYourNewEmail: 'Inserisci la tua nuova email',
  retroSettings: 'Impostazioni Retro',
  enterFacilitatorCode: 'Inserisci il Codice Facilitatore',
  // Modal ariaLabels
  modalCreateAlert: 'Crea Avviso',
  modalUpdateEstimationScale: 'Aggiorna Scala di Stima',
  modalDeleteConfirmation: 'Conferma Eliminazione',
  modalCreateEstimationScale: 'Crea Scala di Stima',
  modalTeamCheckin: 'Check-in del Team',
  modalAddPokerStory: 'Aggiungi Storia Poker',
  modalCreateUser: 'Crea Utente',
  modalCreateApiKey: 'Crea Chiave API',
  modalImportPokerStories: 'Importa Storie Poker',
  modalSetupMultifactorAuth: 'Configura Autenticazione Multifattore',
  modalEditPokerGame: 'Modifica Gioco Poker',
  modalCreateJiraInstance: 'Crea Istanza Jira',
  modalUpdatePokerSettings: 'Aggiorna Impostazioni Poker',
  modalAddStoryboardGoal: 'Aggiungi Obiettivo Storyboard',
  modalViewPokerStory: 'Visualizza Storia Poker',
  modalStoryboardColumnSettings: 'Impostazioni Colonna Storyboard',
  modalEditStoryboard: 'Modifica Storyboard',
  modalStoryboardColorLegend: 'Legenda Colori Storyboard',
  modalStoryboardPersonas: 'Personaggi Storyboard',
  modalRetroActionComments: 'Commenti Azione Retro',
  modalStoryboardStory: 'Storia Storyboard',
  modalTeamAddUser: 'Aggiungi Utente al Team',
  modalCreateDepartment: 'Crea Dipartimento',
  modalCreateTeam: 'Crea Team',
  modalCreateOrganization: 'Crea Organizzazione',
  modalCreateRetroTemplate: 'Crea Modello Retro',
  modalViewRetroTemplateFormat: 'Visualizza Formato Modello Retro',
  modalUpdateRetroTemplate: 'Aggiorna Modello Retro',
  modalAssociateTeamToSubscription: 'Associa Team alla Sottoscrizione',
  modalAssociateOrganizationToSubscription: 'Associa Organizzazione alla Sottoscrizione',
  modalTeamUpdateUser: 'Aggiorna Utente del Team',
  modalSubscriptionForm: 'Modulo Sottoscrizione',
  modalEditRetro: 'Modifica Retro',
  modalEditRetroActionItem: 'Modifica Elemento Azione Retro',
  modalRetroItemComments: 'Commenti Elemento Retro',
  modalUpdateRetroSettings: 'Aggiorna Impostazioni Retro',
  githubRepository: 'Repository GitHub',
  projects: 'Progetti',
  projectCreate: 'Crea progetto',
  projectKey: 'Chiave progetto',
  scope: 'Ambito',
  createdAt: 'Creato il',
  projectRemoveSuccess: 'Progetto rimosso con successo',
  projectRemoveError: 'Errore nella rimozione del progetto',
  removeProjectConfirmText: 'Sei sicuro di voler rimuovere questo progetto? Questa azione non può essere annullata.',
  removeProject: 'Rimuovi progetto',
  modalCreateProject: 'Crea Progetto',
  modalUpdateProject: 'Aggiorna Progetto',
  projectKeyPlaceholder: 'Inserisci la chiave del progetto (es. PROJ)',
  projectNamePlaceholder: 'Inserisci il nome del progetto',
  projectDescriptionPlaceholder: 'Inserisci la descrizione del progetto (opzionale)',
  projectKeyValidationError: 'La chiave del progetto deve essere di 2-10 caratteri alfanumerici',
  projectKeyHelp: '2-10 caratteri, solo lettere e numeri',
  projectScope: 'Ambito del Progetto',
  projectUpdate: 'Aggiorna Progetto',
  projectCreateSuccess: 'Progetto creato con successo',
  projectUpdateSuccess: 'Progetto aggiornato con successo',
  projectCreateError: 'Impossibile creare il progetto',
  projectUpdateError: 'Impossibile aggiornare il progetto',
  project: 'Progetto',
  gameSettings: 'Impostazioni di Gioco',
  endGame: 'Termina Gioco',
  endGameReason: 'Motivo per Terminare il Gioco',
  endGameReasonPlaceholder: 'Inserisci il motivo per terminare il gioco (opzionale)',
  welcomeBack: 'Bentornato,',
  dashboardSubtitle: 'Rendiamo la tua prossima sessione di collaborazione di squadra la migliore di sempre.',
  filterByTeam: 'Filtra per squadra:',
  allTeams: 'Tutte le squadre',
  showContentForAllTeams: 'Mostra contenuto di tutte le squadre',
  clearFilter: 'Cancella filtro',
  teamPage: 'Pagina della squadra',
  dashboardTeamsRequired:
    'Seleziona una squadra per vedere le tue sessioni di planning poker, retrospettive e storyboard.',
  planningPokerSessions: 'Sessioni di Planning Poker',
  viewAllPokerSessions: 'Vedi tutte le sessioni di planning poker',
  totalPokerSessions: '{total} sessioni totali',
  noSessionsFoundForTeam: 'Nessuna sessione trovata per {teamName}',
  noSessionsFound: 'Nessuna sessione trovata',
  trySelectingDifferentTeamForPoker: 'Prova a selezionare una squadra diversa o crea una nuova partita',
  startFirstPlanningPokerSession: 'Inizia la tua prima sessione di planning poker',
  sprintRetrospectives: 'Retrospettive di Sprint',
  viewAllRetros: 'Vedi tutte le retrospettive',
  totalRetros: '{total} retrospettive totali',
  noRetrosFoundForTeam: 'Nessuna retrospettiva trovata per {teamName}',
  startFirstSprintRetrospective: 'Inizia la tua prima retrospettiva di sprint',
  trySelectingDifferentTeamForRetros: 'Prova a selezionare una squadra diversa o crea una nuova retrospettiva',
  viewAllStoryboards: 'Vedi tutti gli storyboard',
  totalStoryboards: '{total} storyboard totali',
  noStoryboardsFoundForTeam: 'Nessuno storyboard trovato per {teamName}',
  startFirstStoryboard: 'Inizia il tuo primo storyboard',
  agileStoryMapping: 'Mappatura agile delle storie',
  trySelectingDifferentTeamForStoryboards: 'Prova a selezionare una squadra diversa o crea un nuovo storyboard',
  supportTickets: 'Ticket di Supporto',
  supportTicketDeleteConfirmation:
    'Sei sicuro di voler eliminare questo ticket di supporto? Questa azione non può essere annullata.',
  supportTicketDelete: 'Elimina Ticket',
  updateSupportTicketSuccess: 'Ticket di supporto aggiornato con successo',
  updateSupportTicketError: 'Impossibile aggiornare il ticket di supporto',
  getSupportTicketsError: 'Impossibile recuperare i ticket di supporto',
  deleteSupportTicketSuccess: 'Ticket di supporto eliminato con successo',
  deleteSupportTicketError: 'Impossibile eliminare il ticket di supporto',
  clear: 'Cancella',
};

export default it;
